module.exports = __webpack_public_path__ + "img/Project_created_clicked.82680dcc.svg";